import React from 'react';
import { FormGroup, Input } from 'reactstrap';
import HelperText from '../@core/components/helper-text';
import { Label } from './Forms';
import { useThemeColors } from '../utility/hooks/useThemeColors';

const TextInput = ({
	caption,
	onChange,
	value,
	disabled,
	type,
	placeholder,
	name,
	maxLength,
	isRequired,
	onBlur,
	errors,
	autoFocus,
	inputProps,
	noInputWrapper,
	onChangeMask,
	toUpperCase,
	...other
}) => {
	const colors = useThemeColors();
	const internalChange = (e) => {
		if (!onChangeMask) {
			return onChange(e);
		}
		const newVal = e.target.value;
		if (!newVal || onChangeMask.test(newVal)) {
			return onChange(e);
		}
	};
	return (
		<FormGroup {...other}>
			<Label isRequired={isRequired}>{caption}</Label>
			<Input
				style={{
					fontFamily: 'Poppins Medium',
					color: colors.gray[700],
					textTransform: toUpperCase && 'uppercase'
				}}
				type={type || 'text'}
				name={name}
				maxLength={maxLength}
				placeholder={placeholder}
				invalid={errors && true}
				onChange={internalChange}
				onBlur={onBlur}
				value={value}
				disabled={disabled}
				autoFocus={autoFocus}
				{...inputProps}
			/>
			<HelperText error={errors} />
		</FormGroup>
	);
};

export default TextInput;
